import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_RECUPER_LOGIN_DEMANDE,
    CONTEXT_RECUPER_LOGIN_REPONSE,
    CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN,
} from '../../../constants/apiUrls.constants';

const recupererLogin = combineReducers({
    demande: APIReducer.bind(null, CONTEXT_RECUPER_LOGIN_DEMANDE),
    validation: APIReducer.bind(null, CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN),
    reponse: APIReducer.bind(null, CONTEXT_RECUPER_LOGIN_REPONSE),
});

export default recupererLogin;
